import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const Leadership = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Inkluderande ledarskap</title>
        <meta
          name="description"
          content="Vi coachar chefer och ledare i inkluderande ledarskap. Läs mer här."
        />
        <meta property="og:title" content="We Exist - Inkluderande ledarskap" />
        <meta
          property="og:description"
          content="Vi coachar chefer och ledare i inkluderande ledarskap. Läs mer här."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Inkluderande ledarskap" />
      <ServicePageWrapper>
        <img
          src="./service-images/inkluderande-ledarskap.jpg"
          alt="woman in office"
        />
        <p>
          Hur skapar man och behåller ett välkomnande klimat för sina kvinnliga
          anställda? Som chef är du drivande i den långsiktiga förändringen och
          du sätter tonen och agendan genom att visa vad som är viktigt i ert
          team. I våra ledarskapsutbildningar går vi bland annat genom hur du på
          bästa sätt bemöter och tar tag i frågor och utmaningar med dina
          anställda på ett inkluderande sätt. Exempel på ämnen vi går igenom är
          rättvisa arbetsförhållanden, löner och anställningsvillkor, balansen
          mellan jobb och föräldraskap samt hur du kommunicerar med dina
          kollegor på ett jämlikt och rättvist sätt. Enligt lag behöver ni som
          företag även ha riktlinjer och rutiner för att förhindra trakasserier
          eller sexuella trakasserier och repressalier. Även detta hjälper vi er
          att få på plats så ni stolt kan visa att ni är We Exist Approved och
          att det ni erbjuder era medarbetare är en jämställd, inkluderande och
          trygg arbetsplats.
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
